const { param } = require("jquery");
const { countBy } = require("lodash");

/**
 * 測定結果管理ページ用のスクリプト
 */
 if (is_route('drive_report.index')) {
    // コンテンツ読み込み後
    $(document).on('amc:onload', function() {
        event_set();
        setting_event_set();
        event_video_control();
    });
}

$(document).on('amc:onload', function() {
    $('#search-form-action_print-all').toggleClass('display-none', ($('.drive_report-check:checked').length == 0));
});

$(document).on('amc:reload', function() {
    $('#search-form-action_print-all').toggleClass('display-none', ($('.drive_report-check:checked').length == 0));
});

/**
 * ページ読み込み時のイベント設定
 */
window.event_set = function() {


    /*---- ページタブ切り替え時 ----*/

    // タブ切り替え時
    $(document).on('click', '[data-page-type]', function() {
        const dateError = $('#search-form-started_at-errors').find('.invalid-feedback').not('.copy');
        if (dateError.text().trim() !== '') {
            $('#search-form-started_at').val('');
            $('#search-form-ended_at').val('');
        }
        const monthError = $('#search-form-month-errors').find('.invalid-feedback').not('.copy');
        if (monthError.text().trim() !== '') {
            $('.month-picker-value[name="month"]').val('');
        }
        $('#search-form-name').val('');
        $('#search-form-vehicle_name').val('');
        $('#search-form-organization_name').val('');
        $('#search-form-type').val($(this).data('page-type'));
        search(true);
    });

    // ボタンクリック時のバブリングを禁止
    $(document).on('click', '.measurement-confirm-before-check, .measurement-confirm-after-check', function (e) {
        // バブリングを禁止
        e.stopPropagation();
    });

    /*---- 検索条件変更時 ----*/

    // 日時（開始）変更時
    $(document).on('change', '#search-form-started_at', function () {
        changeStartedAt(this, '#search-form-ended_at');
    });
    $(document).on('change', '#drive_report-setting-modal-start_time', function () {
        changeStartTime(this, '#drive_report-setting-modal-end_time');
    });

    // 日時（終了）変更時
    $(document).on('change', '#search-form-ended_at', function () {
        changeEndedAt(this, '#search-form-started_at');
    });
    $(document).on('change', '#drive_report-setting-modal-end_time', function () {
        changeEndTime(this, '#drive_report-setting-modal-start_time');
    });

    // monthly社員車両切替
    $(document).on('change', '#search-form-mode', function() {
        if ($(this).val() === 'vehicle') {
            $('#search-form-name').val('');
            $('#search-form-organization_name').val('');
            search(true);
        } else {
            $('#search-form-vehicle_name').val('');
            search(true);
        }
    });

    function changeStartedAt(elm, target)
    {
        let last_day = null;
        selected_date = $(elm).val();
        set_end = $(target).val();
        if(set_end != ''){
            selected_date = new Date(selected_date);
            chk_date_over = new Date(selected_date.getFullYear(),selected_date.getMonth(),selected_date.getDate() + 31);
            chk_date = new Date(selected_date.getFullYear(),selected_date.getMonth(),selected_date.getDate());
            set_end = new Date(set_end);
            yyyymmdd = new Date(set_end.getFullYear(),set_end.getMonth(),set_end.getDate());
            if(chk_date_over.getTime() < yyyymmdd.getTime()){
                yyyymmdd = new Date(selected_date.getFullYear(),selected_date.getMonth(),selected_date.getDate() + 31);
                last_day = yyyymmdd.getFullYear()+'/'+
                        ( "0"+( yyyymmdd.getMonth()+1 ) ).slice(-2)+'/'+
                        ( "0"+yyyymmdd.getDate() ).slice(-2);
                $(target).val(last_day);
            }else if(chk_date.getTime() > yyyymmdd.getTime()){
                last_day = chk_date.getFullYear()+'/'+
                        ( "0"+( chk_date.getMonth()+1 ) ).slice(-2)+'/'+
                        ( "0"+chk_date.getDate() ).slice(-2);
                $(target).val(last_day);
            }
        }
    }

    function changeStartTime(elm, target)
    {
        let last_day = null;
        selected_date = $(elm).val();
        set_end = $(target).val();
        // console.log(selected_date);
        // console.log(set_end);
        if(set_end != '' && selected_date != ''){
            chk_date = moment(new Date(selected_date));
            yyyymmdd = moment(new Date(set_end));

            if(chk_date.format('X') > yyyymmdd.format('X')) {
                // 時間のみ相違のときは日付-1する
                if (yyyymmdd.format('YYYYMMDD') === chk_date.format('YYYYMMDD')) {
                    last_day = chk_date.subtract(1, 'days').format('YYYY/MM/DD kk:mm');
                } else {
                    last_day = yyyymmdd.format('YYYY/MM/DD') + ' ' + chk_date.format('kk:mm');
                }
                $(elm).val(last_day);
            }
        }
    }

    function changeEndedAt(elm, target)
    {
        let last_day = null;
        selected_date = $(elm).val();
        set_start = $(target).val();
        if(set_start != ''){
            selected_date = new Date(selected_date);
            set_start = new Date(set_start);
            yyyymmdd = new Date(set_start.getFullYear(),set_start.getMonth(),set_start.getDate() + 31);
            yyyymmdd_2 = new Date(set_start.getFullYear(),set_start.getMonth(),set_start.getDate());
            if(selected_date.getTime() > yyyymmdd.getTime()){
                last_day = yyyymmdd.getFullYear()+'/'+
                        ( "0"+( yyyymmdd.getMonth()+1 ) ).slice(-2)+'/'+
                        ( "0"+yyyymmdd.getDate() ).slice(-2);
                $(elm).val(last_day);
            }else if(selected_date.getTime() < yyyymmdd_2.getTime()){
                last_day = yyyymmdd_2.getFullYear()+'/'+
                        ( "0"+( yyyymmdd_2.getMonth()+1 ) ).slice(-2)+'/'+
                        ( "0"+yyyymmdd_2.getDate() ).slice(-2);
                $(elm).val(last_day);
            }
        }
    }

    function changeEndTime(elm, target)
    {
        let last_day = null;
        selected_date = $(target).val();
        set_end = $(elm).val();
        // console.log(selected_date);
        // console.log(set_end);
        if(set_end != ''){
            selected_date = new Date(selected_date);
            chk_date = new Date(selected_date.getFullYear(),selected_date.getMonth(),selected_date.getDate(),selected_date.getHours(),selected_date.getMinutes(),selected_date.getSeconds());
            set_end = new Date(set_end);
            yyyymmdd = new Date(set_end.getFullYear(),set_end.getMonth(),set_end.getDate(),set_end.getHours(),set_end.getMinutes(),set_end.getSeconds());
            if(chk_date.getTime() > yyyymmdd.getTime()){
                last_day = chk_date.getFullYear()+'/'+
                        ( ( chk_date.getMonth()+1 ) )+'/'+
                        ( chk_date.getDate() )+' '+( chk_date.getHours() )+':'+( chk_date.getMinutes() )+':'+( chk_date.getSeconds() );
                $(elm).val(last_day);
            }
        }
    }

    /**
     * 検索条件を返却
     * @param {*} isClear
     * @returns
     */
    function getConditions(isClear)
    {
        let datas = $('#search-form').serializeArray();
        datas.push({ 'name' : 'is_clear', 'value' : isClear});
        return datas;
    }

    // グループ会社変更時
    $(document).on('change', '#search-form-holding_id', function () {
        var action = $('#search-form').attr('action').replace('/list', '');
        if($(this).val() == ''){
            location.href = action;
            return false;
        }
        let excutionData = [];
        excutionData.push('company_id', 'section_id', 'page');
        action = _request.create_affiliation_url(action, true, [{'name': 'holding_id', 'value': $(this).val()}], excutionData);
        location.href = action;
        return false;
    });

    // 会社変更時
    $(document).on('change', '.search-form-company-select', function() {
        _select.set_select(this, 'select.search-form-section-select', {'company_id': $(this).val()});
    });

    /*---- 履歴表示時 ----*/

    // 詳細表示時
    $(document).on('click', '.show_detail', function () {
        _modal.create($(this).parent("tr"), 'detail-modal', ['id', 'started_at', 'ended_at']);
        return false;
    });


    // 編集ボタン押下時：測定結果一覧を表示する
    $(document).on('click', '[data-reassign-modal]', function () {
        let holding_id = $('#search-form-holding_id').val();
        let company_id = $('#search-form-company_id').val();
        let section_id = $(this).data('section_id');
        let started_at = $('#search-form-started_at').val();
        let ended_at = $('#search-form-ended_at').val();
        _modal.create_with_data(this, 'reassign-modal', {'holding_id': holding_id, 'company_id': company_id, 'section_id': section_id, 'started_at': started_at, 'ended_at': ended_at});
    });

    /*---- 設定表示時 ----*/

    // 設定表示時
    $(document).on('click', '[data-setting-modal]', function () {
        let datas = $('#search-form').serializeArray();
        datas.push({'name': 'id', 'value': $(this).data('id')});
        _modal.create_with_data(this, 'setting-modal', datas);
    });

    /*---- 設定保存時 ----*/

    // 設定保存時
    $(document).on('click', '#drive_report-setting-modal [data-save-modal]', function () {
        drive_report_modal_submit(this, 'save-modal', function() {
            $('#search-form-started_at').trigger('change');
        });
    });

    /*---- 削除確認の表示時 ----*/

    // 設定表示時
    $(document).on('click', '[data-confirm-modal]', function () {
        // console.log('confirm');
        // 設定モーダルを表示
        _modal.create(this, 'confirm-modal', ['id']);
    });

    /*---- 削除時 ----*/

    // 削除実行時
    $(document).on('click', '[data-delete-modal]', function () {
        _modal.submit(this, 'delete-modal');
    });

    /*---- 検索ボタン押下時 ----*/
    $(document).on('click', '#search-form-action_search', function () {
        $(this).prop('disabled', true);
        search();
    });

    /**
     * 検索処理
     * @param {*} conditions
     * @param {*} isClear
     * @returns
     */
    function search(isClear=false)
    {
        let datas = getConditions(isClear);
        let excutionData = [];
        excutionData.push('holding_id', 'company_id', 'section_id', 'type', 'mode', 'page');
        var action = $('#search-form').attr('action').replace('/list', '');
        action = _request.create_affiliation_url(action, true, datas, excutionData);
        location.href = action;
        return false;
    }

    /*---- 印刷ボタン押下時 ----*/

    // 印刷時
    $(document).on('click', '#search-form-action_print, #search-form-action_print-all', function () {
        var ids = ($(this).data('id') == null ? [] : [$(this).data('id')]);
        if ($(this).data('id') == null) {
            $('.drive_report-check[name="ids[]"]:checked').map(function() {
                ids.push($(this).val());
            });
        }
        // console.log(ids);
        // 送信値を配列化
        let datas = $('#search-form').serializeArray();
        datas.push({'name': 'ids', 'value': ids});
        let action = extend_url_query($(this).data('action'));
        // BlobでPDFを別ウィンドウで表示
        _ajax.blob(action, datas, function (blob) {
            window.open(window.URL.createObjectURL(blob), '_blank');
        }, function(xhr, status, errorThrown){
            _error.omitted(xhr, status, errorThrown);
        });
    });

    // 一括のチェックボックスクリック時
    $(document).on('click', '#drive_report-all-check', function () {
        $(".drive_report-check").prop('checked', $(this).prop('checked'));
    });
    // 一覧のチェックボックスクリック時
    $(document).on('click', '.drive_report-check', function (e) {
        // バブリングを禁止
        e.stopPropagation();
    });
    $(document).on('change', '#drive_report-all-check, .drive_report-check', function () {
        $('#search-form-action_print-all').toggleClass('display-none', ($('.drive_report-check:checked').length === 0));
    });

    /*---- 一括確認制御 ----*/
    // 一括のチェックボックスクリック時
    $(document).on('click', '#drive_report_approval-all-check', function () {
        $(".drive_report_approval-check").not(':disabled').prop('checked', $(this).prop('checked'));
    });
    // 一覧のチェックボックスクリック時
    $(document).on('click', '.drive_report_approval-check', function (e) {
        // バブリングを禁止
        e.stopPropagation();
    });
    $(document).on('change', '#drive_report_approval-all-check, .drive_report_approval-check', function () {
        $('#drive_report-monthly_detail-modal-approve_all').prop('disabled', ($('.drive_report_approval-check:checked').length === 0));
    });

    /*---- 検索時 ----*/
    $(document).on('change', '#drive_report-reassign-modal-section_id, #drive_report-reassign-modal-user_id, #drive_report-reassign-modal-started_at, #drive_report-reassign-modal-ended_at', function() {
        // console.log('change');
        let form = $(this).parents('form');
        let datas = $(form).serializeArray();
        let action = $(form).attr('action');
        let modalId = $(form).data('modal_id');
        _modal.update(modalId, action, datas);
    });

    /*---- 月一覧処理 ----*/

    // 月毎の詳細画面表示
    $(document).on('click', '[data-monthly_detail-modal] td', function () {
        // click-throughクラス設定時は、スルー
        if ($(this).hasClass('click-through')) {
            return false;
        }
        _modal.create($(this).parent('tr'), 'monthly_detail-modal', ['user_id', 'vehicle_id'], true, function(){
            // 一括確認ボタン活性制御
            // リストにボタン自体がない時は表示しない
            if ($('#drive_report-monthly_detail-modal-detail_list td button').length === 0) {
                $('#drive_report-monthly_detail-modal-approve_all').parents('div.navi').addClass('d-none');
            } else {
                // 初期表示時は非活性にする
                $('#drive_report-monthly_detail-modal-approve_all').prop('disabled', true).removeClass('btn-default').addClass('btn-warning');
            }
        });
    });

    /*---- 個別確認・取消ボタン押下 ----*/

    $(document).on('click', '[data-approval]', function ()
    {
        let action = extend_url_query($(this).data('action'));
        let params = [
            {'name': 'approval', 'value': $(this).data('approval')},
            {'name': 'mode_model_id', 'value': $(this).data('mode_model_id')}   // 詳細モーダル再表示のためuser_id or vehicle_id引継ぎ
        ];
        let ids = $(this).data('ids');
        params.push({'name': 'ids', 'value': ids.toString().split(',')});

        _ajax.post(action, params, function (result) {
            // 完了メッセージをセットする
            _complete.set(result);
            if (result.type === 'monthly') {
                // 月毎の詳細モーダル再表示
                _modal.hide('#drive_report-monthly_detail-modal');
                $('[data-monthly_detail-modal][data-' + result.mode + '_id="' + result.mode_model_id + '"] td:first').trigger('click');
            } else {
                // 画面再表示
                load_contents();
            }
        }, function(xhr, status, errorThrown){
            _error.omitted(xhr, status, errorThrown);
        });
    });

    /*---- 一括確認 ----*/

    // 一括確認確認
    $(document).on('click', '[data-approval_confirm-modal]', function () {
        let params = [
            {'name': 'approval', 'value': 1},
            {'name': 'mode_model_id', 'value': $(this).data('mode_model_id')}
        ];
        // 確認対象id取得
        $('input[type="checkbox"].drive_report_approval-check:checked').map(function(index, element){
            params.push({'name': 'ids[]', 'value': element.value});
        });
        _modal.create_with_data(this, 'approval_confirm-modal', params, true);
    });

    // 一括確認実行
    $(document).on('click', '[data-approval-all]', function () {
        let form = $('#drive_report-approval_confirm-modal-form');
        let action = form.attr('action');
        let params = form.serializeArray();

        _ajax.post(action, params, function (results) {
            // 完了メッセージをセットする
            _complete.set(results);
            // 一括確認確認モーダルを閉じる
            _modal.hide('#drive_report-approval_confirm-modal');
            if (results.type === 'monthly') {
                // 月毎の詳細モーダル再表示
                _modal.hide('#drive_report-monthly_detail-modal');
                $('[data-monthly_detail-modal][data-' + results.mode + '_id="' + results.mode_model_id + '"] td:first').trigger('click');
            } else {
                // 画面再表示
                load_contents();
            }
        });
    });

    /*---- 月毎印刷 ----*/

    // 月合計印刷ボタン押下時
    $(document).on('click', '#search-form-monthly_print', function () {
        let action = extend_url_query($(this).data('action'));
        let params = $('#search-form').serializeArray();
        // BlobでPDFを別ウィンドウで表示
        _ajax.blob(action, params, function (blob) {
            window.open(window.URL.createObjectURL(blob), '_blank');
        }, function(xhr, status, errorThrown){
            _error.omitted(xhr, status, errorThrown);
        });
    });

    // 月明細印刷ボタン押下->印刷設定表示
    $(document).on('click', '[data-monthly_print_setting]', function () {
        _modal.create($(this), 'monthly_print_setting', ['vehicle_id'], true, function(){
            print_setting_event_set();
        });
    });

    // 月明細適用ボタン押下->帳票出力
    $(document).on('click', '#monthly_detail_print', function () {
        let form = $('#drive_report-monthly_print_setting-modal-form');
        let action = extend_url_query(form.attr('action'));
        let params = form.serializeArray();
        // BlobでPDFを別ウィンドウで表示
        _ajax.blob(action, params, function (blob) {
            window.open(window.URL.createObjectURL(blob), '_blank');
        }, function(xhr, status, errorThrown){
            _error.omitted(xhr, status, errorThrown);
        });
    });
    
    /*---- CSVの出力時 ----*/

    // 月合計CSV（車両モード）->稼働率算出方法設定モーダル
    $(document).on('click', '[data-csv_download_setting]', function () {
        _modal.create($(this), 'csv_download_setting', [], true);
    });

    //月合計CSV（車両モード）->ダウンロード実行
    $(document).on('click', '#monthly_csv_download_vehicle', function () {
        let form = $('#drive_report-csv_download_setting-modal-form');
        let action = extend_url_query($(this).data('action'));
        let params = $($(this).data('form')).serializeArray();
        params = params.concat(form.serializeArray());

        //祝日（土日以外）の日数を取得
        let yearMonth = params.find(p => p.name === 'month').value;
        let [year, month] = yearMonth.split('-').map(Number);
        let nationalHolidays = holidayJp.between(new Date(yearMonth + '-01'), new Date(year, month, 0));
        let notSatSunHolidayCount = 0;
        for (let i = 0 ; i < Object.keys(nationalHolidays).length ; i ++) {
            if (!(nationalHolidays[i].week_en === 'Saturday' || nationalHolidays[i].week_en === 'Sunday')) {
                notSatSunHolidayCount ++ ;
            }
        }
        params = params.concat({name: 'notSatSunHolidayCount', value: notSatSunHolidayCount});

        //post
        post(action, params);
        // モーダルを閉じる
        _modal.hide('#drive_report-csv_download_setting-modal');

    });

    // CSVの出力時
    $(document).on('click', '[data-csv-type]', function ()
    {
        if ($(this).hasClass('disabled')) {
            return false;
        }
        // アクションの取得
        let action = extend_url_query($(this).data('action'));
        // 検索フォームを配列化
        let datas = $('#search-form').serializeArray();
        // データを追加
        datas.push({'name' : 'csv_type', 'value' : $(this).data('csv-type')});
        // ポスト送信を実行
        post(action, datas);
    });

    function getPostData()
    {
        return {
            'holding_id' :$('#drive_report-reassign-modal-holding_id').val(),
            'company_id' :$('#drive_report-reassign-modal-company_id').val(),
            'section_id' :$('#drive_report-reassign-modal-section_id').val(),
            'user_id' :$('#drive_report-reassign-modal-user_id').val(),
            'started_at' :$('#drive_report-reassign-modal-started_at').val(),
            'ended_at' :$('#drive_report-reassign-modal-ended_at').val(),
        };
    }

    // 初期表示時に選択状態とする
    $("#drive_report-all-check").trigger('change');

    /*---- 運行詳細モーダル ----*/

    // 運行詳細モーダル表示時
    $(document).on('click', '[data-drive_details-modal]', function () {
        let datas = $('#search-form').serializeArray();
        datas.push({'name': 'id', 'value': $(this).data('id')});
        datas.push({'name': 'exsist_event_video', 'value': $(this).data('exsist_event_video')});
        datas.push({'name': 'exsist_yuricargo', 'value': $(this).data('exsist_yuricargo')});
        _modal.create_with_data(this, 'drive_details-modal', datas, false, function() {
            /*
            if (($('#yuricargo_details').length > 0 && $('#yuricargo_details').hasClass('active')) || $('#event_video_details').hasClass('only-locations')) {
                $('#drive_details_modal .modal-drive_report').css('width', '650px');
            } else {
                $('#drive_details_modal .modal-drive_report').css('width', '68%');
            }
                */

            setTimeout(function(){
                createMap();
            },1000);
        });
    });


    // 動画表示へ切り替え
    $(document).on('click', '#show-video-btn', function () {
        $("#event-video-map-box").hide();
        $("#video-contents-box").show();
        $(this).addClass('active');
       $('#show-map-btn').removeClass('active');
    });

   // 地図表示へ切り替え
   $(document).on('click', '#show-map-btn', function () {
       $("#video-contents-box").hide();
       $("#event-video-map-box").show();
       $(this).addClass('active');
       $('#show-video-btn').removeClass('active');
       $('#video-map div:first').css('width', $('#event_video_details').find('.video-map').width() + 'px');
   });
/*
    // 運行詳細モーダル内の「イベント動画」or「Yuricargo」ボタンクリック時 (地図を追加して不要となったためコメントアウト)
    $(document).on('click', '#event_video_details-tab, #yuricargo_details-tab', function () {
        if ($(this).is('#event_video_details-tab')) {
            $('#drive_details_modal .modal-drive_report').css('width', '68%');
        } else if ($(this).is('#yuricargo_details-tab')) {
            $('#drive_details_modal .modal-drive_report').css('width', '650px');
        }
    });
*/
    /*---- 安全運転解析結果詳細表示時 ----*/

    // 安全運転解析結果詳細表示時
    $(document).on('click', '[data-safety-drive-analysis-detail-modal]', function () {
        _modal.create(this, 'safety-drive-analysis-detail-modal', ['id'], false, function() {
            const yuricargoTripRows = $('#drive_report-safety_drive_analysis_detail-modal tr.yuricargo-trip-row');
            // トリップが複数ある場合、行のクリックによって表示するイベント情報を切り替える
            if (yuricargoTripRows.length > 1) {
                $(document).on('click', '#drive_report-safety_drive_analysis_detail-modal tr.yuricargo-trip-row', function() {
                    const tripIndex = $(this).data('trip-index');
                    yuricargoTripRows.toggleClass('selected-trip', false);
                    $(this).toggleClass('selected-trip', true);
                    $('#drive_report-safety_drive_analysis_detail-modal .tab-content').toggleClass('d-none', true);
                    $('#drive_report-safety_drive_analysis_detail-modal .tab-content[data-event-index="'+ tripIndex +'"]').toggleClass('d-none', false);
                });
            }
        });
    });

    /*---- トリップ削除確認の表示時 ----*/

    // 削除確認モーダル表示時
    $(document).on('click', '[data-safety_drive_delete_confirm-modal]', function (e) {
        e.stopPropagation();
        _modal.create(this, 'safety_drive_delete_confirm-modal', ['yuricargo_trip_id']);
    });

    /*---- 削除時 ----*/

    // 削除実行時
    $(document).on('click', '[data-safety_drive_delete-modal]', function () {
        _modal.submit(this, 'safety_drive_delete-modal', null, null, '-form', false, function() {
            _modal.hide('#drive_report-safety_drive_analysis_detail-modal');
        });
    });

    /*---- 安全運転解析 ----*/

    // 解析確認時
    $(document).on('click', '[data-analyze_confirm-modal]', function () {
        _modal.create(this, 'analyze_confirm-modal', ['id', 'analyze_yuricargo_flag', 'analyze_drive_location_flag']);
    });

    // 解析実行時
    $(document).on('click', '[data-analyze-modal]', function (e) {
        var modalId = create_id($(this).data('analyze-modal'));
        var formId = modalId + '-form';
        // 送信前にエラーをリセット
        _error.reset()
        $('#analysis-error-message').html("");
        // post送信
        _ajax.submit(formId, function (results) {
            if (results.errorMessage == '') {
                // メッセージ表示
                if (results.successMessage != '') {
                    toastr.success(results.successMessage);
                }
                if (results.faildMessage != '') {
                    toastr.warning(results.faildMessage);
                }
                // モーダルを閉じる
                _modal.hide(modalId);
                // コンテンツ再読み込み
                load_contents();
            } else {
                $('#analysis-error-message').html(results.errorMessage);
            }
        }, function(xhr, status, errorThrown){
            _error.set(xhr, status, errorThrown);
        });
    });

    // モーダル上に地図を生成
    function createMap() {

        let vehicleData = $('#event_video_details').find('.video-map').data('eventvideo_map_data');
        let zMapMain = $('#event_video_details').find('.video-map');
        let polylineLociLatlon = [];
        let options = {
            addressOfMarker: false,
            zoom: 11,
        };
        if (zMapMain.length > 0) {
            zMapMain.empty();
            //地図を作成
            zMapMain.attr('width', zMapMain.width() + 'px');
            zMapMain.attr('height', zMapMain.height() + 'px');
            if (zMapMain.data('zip_lat') !== '' || zMapMain.data('zip_lon') !== '') {
                options.lat = zMapMain.data('zip_lat');
                options.lon = zMapMain.data('zip_lon');
            }
            _zdcMap.Map.init(zMapMain, options, false);
            if(vehicleData.length > 0) {
                //地図上に経路の線を引く
                $.each(vehicleData, function(i, item){
                    polylineLociLatlon.push(new ZDC.LatLon(item.latitude, item.longitude));
                });
                polylineLoci = new ZDC.Polyline(
                    polylineLociLatlon,
                    {
                        strokeColor: '#669DF6',
                        strokeWeight: 3,
                    }
                );
                _zdcMap._zMap.addWidget(polylineLoci);

                //地図上にイベントを示す円を描く
                $.each(vehicleData, function(i, item){
                    if(item.back > 0 || item.brake > 0 || item.blinker > 0) {
                        eventOval = new ZDC.Oval(
                            {
                                latlon: new ZDC.LatLon(item.latitude, item.longitude),
                                x:      5,
                                y:      5,
                            },
                            {
                                strokeColor: '#000000',
                                strokeWeight: 2,
                                fillColor:'#FF0000',
                            }
                        );
                        _zdcMap._zMap.addWidget(eventOval);
                    }
                });

                //地図上に開始地点を示すマーカーを描く
                startMarker = new ZDC.Marker(
                    new ZDC.LatLon(vehicleData[0].latitude, vehicleData[0].longitude),
                    {
                        /* マーカのサイズに合わせて位置を調整する */
                        offset: new ZDC.Pixel(-17, -32),
                        custom: {
                            base : {
                                src: '../../images/icon_event.png'
                            }
                        }
                    }
                );
                _zdcMap._zMap.addWidget(startMarker);

                //地図上に終了地点を示すマーカーを描く
                endMarker = new ZDC.Marker(
                    new ZDC.LatLon(vehicleData.slice(-1)[0].latitude, vehicleData.slice(-1)[0].longitude),
                    {
                        /* マーカのサイズに合わせて位置を調整する */
                        offset: new ZDC.Pixel(-17, -32),
                        custom: {
                            base : {
                                src: '../../images/icon_event.png'
                            }
                        }
                    }
                );
                _zdcMap._zMap.addWidget(endMarker);
            }
        }

        let yuricargoVehicleData = $('#yuricargo_details').find('.yuricargo-map').data('yuricargo_map_data');
        let yuricargozMapMain = $('#yuricargo_details').find('.yuricargo-map');
        let yuricargoPolylineLociLatlon = [];

        if (yuricargozMapMain.length > 0) {
            yuricargozMapMain.empty();
            //地図を作成
            yuricargozMapMain.attr('width', yuricargozMapMain.width() + 'px');
            yuricargozMapMain.attr('height', yuricargozMapMain.height() + 'px');
            if (yuricargozMapMain.data('zip_lat') !== '' || yuricargozMapMain.data('zip_lon') !== '') {
                options.lat = yuricargozMapMain.data('zip_lat');
                options.lon = yuricargozMapMain.data('zip_lon');
            }
            _zdcMap.Map.init(yuricargozMapMain, options, false);
            if(yuricargoVehicleData.length > 0) {
                //地図上に経路の線を引く
                $.each(yuricargoVehicleData, function(i, item){
                    yuricargoPolylineLociLatlon.push(new ZDC.LatLon(item.latitude, item.longitude));
                });
                polylineLoci = new ZDC.Polyline(
                    yuricargoPolylineLociLatlon,
                    {
                        strokeColor: '#669DF6',
                        strokeWeight: 3,

                    }
                );
                _zdcMap._zMap.addWidget(polylineLoci);

                //地図上にイベントを示す円を描く
                $.each(yuricargoVehicleData, function(i, item){
                    if(item.back > 0 || item.brake > 0 || item.blinker > 0) {
                        eventOval = new ZDC.Oval(
                            {
                                latlon: new ZDC.LatLon(item.latitude, item.longitude),
                                x:      5,
                                y:      5,
                            },
                            {
                                strokeColor: '#000000',
                                strokeWeight: 2,
                                fillColor:'#FF0000',
                            }
                        );
                        _zdcMap._zMap.addWidget(eventOval);
                    }
                });

                //地図上に開始地点を示すマーカーを描く
                startMarker = new ZDC.Marker(
                    new ZDC.LatLon(yuricargoVehicleData[0].latitude, yuricargoVehicleData[0].longitude),
                    {
                        /* マーカのサイズに合わせて位置を調整する */
                        offset: new ZDC.Pixel(-17, -32),
                        custom: {
                            base : {
                                src: '../../images/icon_event.png'
                            }
                        }
                    }
                );
                _zdcMap._zMap.addWidget(startMarker);

                //地図上に終了地点を示すマーカーを描く
                endMarker = new ZDC.Marker(
                    new ZDC.LatLon(yuricargoVehicleData.slice(-1)[0].latitude, yuricargoVehicleData.slice(-1)[0].longitude),
                    {
                        /* マーカのサイズに合わせて位置を調整する */
                        offset: new ZDC.Pixel(-17, -32),
                        custom: {
                            base : {
                                src: '../../images/icon_event.png'
                            }
                        }
                    }
                );
                _zdcMap._zMap.addWidget(endMarker);
            }
        }
    }

    // タイマーの受取変数
    var timer = 0;
    // ウィンドウがリサイズされたとき
    window.addEventListener("resize", function(){
        // リサイズしているときは、タイマーをリセットする
        clearTimeout(timer);

        // 指定時間後、一度だけ処理を実行

        timer = setTimeout(function(){
            console.log($('#event_video_details').find('.video-map').width());
            $('#video-map div:first').css('width', $('#event_video_details').find('.video-map').width() + 'px');
        }, 400);

        timer = setTimeout(function(){
            $('#yuricargo-map div:first').css('width', $('#yuricargo_details').find('.yuricargo-map').width() + 'px');
        }, 400);
    });

    $(document).on('click', '#event_video_details-tab' , function () {
        $('#video-map div:first').css('width', $('#event_video_details').find('.video-map').width() + 'px');
    });

    $(document).on('click', '#yuricargo_details-tab' , function () {
        $('#yuricargo-map div:first').css('width', $('#yuricargo_details').find('.yuricargo-map').width() + 'px');
    });
}


/**
 * 設定モーダル表示時のイベント設定
 */
 window.setting_event_set = function()
 {
     // 日時（終了）カーソルセット時、入力無ければ開始日時セット
     $(document).on('click', '#drive_report-setting-modal-end_time', function () {
         let start = $('#drive_report-setting-modal-start_time').val();
         if ($(this).val() === '' && start !== '') {
             $(this).datetimepicker('defaultDate', start);
         }
     });

     /*---- 行先情報の追加ボタンを押下(行先入力項目を追加する) ----*/

     $(document).on('click', 'button[name="add_destination"]', function() {
         var count = $('#create-destination-block .record-row').length;
         var row = $('#create-destination-block .record-row:first').clone();

         // 削除項目あれば消す
         row.find('input[name^="destination_delete"]').remove();
         row.find('#label_destination_delete').remove();

         // 追加要素の初期化
         row.find('input').each(function() {
             $(this).val('');
             var id = $(this).attr('id');
             var newId = id.replace(/_0/g , '_' + count);
             var label = row.find('label[for="' + id + '"]');
             var error = row.find('#' + id + '-errors');

             // ID、name書き換え
             $(this).attr('id', newId);
             label.attr('for', newId);
             row.find('input[name^="destination_id"]').attr('name', 'destination_id[' + count + ']');
             row.find('input[name^="destination_time"]').attr('name', 'destination_time[' + count + ']');
             row.find('input[name^="destination_name"]').attr('name', 'destination_name[' + count + ']');

             // error初期化
             if (error.length > 0) {
                 error.attr('id', newId + '-errors');
                 error.find('span').html('');
             }
         });

         // 最後に追加
         row.insertBefore($(this).parent('.row'));

         initialize('datepicker');

         // max件になったら追加ボタン殺す
         if (count + 1 >= ($(this).data('row_max') || 20)) {
             $(this).prop('disabled', true);
         }
     });

}

/**
 * 印刷設定モーダル表示時のイベント設定
 */
window.print_setting_event_set = function()
{
    /*-- 出力点検項目 --*/

    // 初期表示
    if ($('input[name="daily_check_items[]"]:checked').length >= 3) {
        $('input[name="daily_check_items[]"]:not(:checked)').prop('disabled', true).parent('label').addClass('disabled');
    }

    // チェック変更時
    $(document).on('change', 'input[name="daily_check_items[]"]', function () {
        // 最大3つまで選択可
        let checked = $('input[name="daily_check_items[]"]:checked');
        if (checked.length >= 3) {
            $('input[name="daily_check_items[]"]:not(:checked)').prop('disabled', true).parent('label').addClass('disabled');
        } else {
            $('input[name="daily_check_items[]"]').prop('disabled', false).parent('label').removeClass('disabled');
        }
    });

    /*-- 出力項目 --*/

    // 初期表示
    // 総走行距離(km)&給油量(L) / 開始メーター/終了メーター はセットで扱い、どちらかのみの選択とする
    let checked = $('input[name="columns[]"]:checked');
    if (checked.length === 0) {
        // init
        setCheck(['refuel', 'mileage']);
    } else {
        checked.each(function() {
            setCheck($(this).data('includes').split(','));
            setUnCheck($(this).data('excludes').split(','));
        });
    }

    // チェック変更時
    $(document).on('change', 'input[name="columns[]"]', function () {
        if ($(this).prop('checked')) {
            setCheck($(this).data('includes').split(','));
            setUnCheck($(this).data('excludes').split(','));
        } else {
            setUnCheck($(this).data('includes').split(','));
            setCheck($(this).data('excludes').split(','));
        }
    });

    // セット項目をチェックする
    function setCheck(includes = [])
    {
        $.each(includes, function(key, include) {
            $('input#drive_report-monthly_print_setting-modal-' + include).prop('checked', true)
                .parent('label').addClass('active');
        });
    }

    // 排他項目をアンチェックする
    function setUnCheck(excludes = [])
    {
        $.each(excludes, function(key, exclude) {
            $('input#drive_report-monthly_print_setting-modal-' + exclude).prop('checked', false)
                .parent('label').removeClass('active');
        });
    }
}

/**
 * 運行日誌モーダルのsubmit処理を実行する
 * @param {*} elm
 * @param {*} modalIdDataSelector
 * @param {*} callback
 */
window.drive_report_modal_submit = function(elm, modalIdDataSelector, callback){
    var modalId = create_id($(elm).data(modalIdDataSelector));
    var formId = modalId + '-form';
    // 送信前にエラーをリセット
    _error.reset()
    // post送信
    _ajax.submit(formId, function (results) {
        // 完了メッセージをセットする
        _complete.set(results);
        // モーダルを閉じる
        _modal.hide(modalId);
        if(callback != null){
            callback(results);
        }
    }, function(xhr, status, errorThrown){
        // エラーをセットする
        _error.set(modalId, xhr, status, errorThrown, false);
    });
}

